<template>
  <div>
    <div ref="supplier_selector">
      <BaseSelectorField
        v-model="query_params.search"
        :multiple="multiple"
        :selectedItems="selectedItems"
        :objectName="multiple ? null : selectedItems[0]?.name"
        :placeholder="disabled ? null : `Select ${!multiple ? modelName.singular : modelName.plural}`"
        :inputClasses="inputClasses"
        :label="label"
        :disabled="disabled"
        :validation="validation"
        :hasWarning="hasWarning"
        :warningMessage="warningMessage"
        :hideMessage="hideMessage"
        :loading="loading || addLoading"
        :searching="searching"
        :required="required"
        :isVoid="isVoid"
        @open-dialog="openModal"
        @clear-selection="clearSelection"
        @focus="handleFieldFocus"
        @blur="handleFieldBlur"
        @query="query"
        @remove-item="removeItem"
        tabindex="1"
      />

      <BaseDialogSelectorList
        displayName="name"
        matchKey="id"
        :open="listVisible"
        :items="query_data?.results"
        :target="$refs.supplier_selector"
        :searching="searching"
        :selectedItems="selectedItems"
        :modelName="modelName"
        :enableNew="!disableAdd"
        @selected="selectItem"
        @create="create"
        @clear="clearSelection"
        @update:open="listVisible = $event"
      />
    </div>

    <SupplierModal v-if="!disableAdd && !disableModals" :newDetails="supplierData" ref="new_modal" @upserted="selectItem([$event])" />

    <BaseSelectorDialog 
      v-model="query_params.search" 
      ref="dialog" 
      :modelName="modelName" 
      :disableAdd="disableAdd"
      :loading="addLoading"
      @create="create" 
      @openNew="openNew"
      @open="dialogOpen = true"
      @close="dialogOpen = false"
    >
      <template #filters>
        <slot name="filters"></slot>
      </template>

      <template #table>
        <BaseTable
          ref="table"
          :selectMode="multiple ? 'multi' : 'single'"
          :data_="query_data"
          :fields="fields"
          :selected.sync="selectedItems"
          :defaultPageSize="query_params.page_size"
          :modelName="modelName"
          :loading="queryLoading"
          @page_change="query_params.page = $event"
          @page_size_change="query_params.page_size = $event"
          @ordering_change="query_params.ordering = $event"
          @selected="() => { if (!multiple) $refs.dialog.hide() }"
          :rowClickable="!multiple"
        />
      </template>
    </BaseSelectorDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BaseDialogSelector from "@/components/shared/BaseDialogSelectors/BaseDialogSelector.vue";
import SupplierModal from "@/router/views/suppliers/SupplierModal.vue";

export default {
  extends: BaseDialogSelector,
  components: {
    SupplierModal,
  },
  props: {
    label: { type: String, default: "Supplier", },
  },
  computed: {
    supplierData() {
      const inputValue = this.query_params.search ? this.query_params.search.trim() : "";
      
      const result = {
        name: null,
        contact_number: null,
        email: null,
      };
      
      if (!inputValue) return result;
      
      const phoneRegex = /^[+\d()\- ]+$/;
      const emailRegex = /^[^\s@]+@[^\s@]+$/;
      
      if (phoneRegex.test(inputValue)) {
        result.contact_number = inputValue;
      } else if (emailRegex.test(inputValue)) {
        result.email = inputValue;
      } else {
        result.name = inputValue.trim();
      }
      
      return result;
    }
  },
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        "contact_number",
        "email",
      ],
      modelName: { singular: "Supplier", plural: "Suppliers" },
    };
  },
  methods: {
    ...mapActions("suppliers", ["fetchSuppliers"]),

    openNew(e) {
      const url = this.$router.resolve('/suppliers/supplier/edit').href;
      window.open(url, '_blank');
    },

    query() {
      this.queryLoading = true;
      this.searching = true;
      this.fetchSuppliers({
          ...this.query_params,
      }).then((res) => {
          this.query_data = res.data;
      }).finally(() => {
        this.queryLoading = false;
        this.searching = false;
      });
    },
  },
};
</script>